import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import { cityActionId, countryActionId, adminUserRoleListActionId, sponsorshipTypeActionId, toastError, toastSuccess, roleListActionId, exhibitionActionId } from "../../../utils/constants";
import DatePicker from "react-datepicker";
import Footer from '../../../common_components/Footer';
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../utils/pagination";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getSponsershipList_action } from "../../../actions/exhibitor_module_actions/sponsorship_action/sponsorship_action";


class SponsorshipList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sponsorshipList: [],
            sponsorshipTypeId: '',
            isLoading: false,
            ExhCompanyName: '',
            VisitorCompanyName: '',
            SponsorshipTypeId: '',
            currentPage: 1,
            ExhibitorList: [],
            VisitorList: [],
            mode: 1,
            companyName: '',
            sponsorshipTypeId: '',
            selectedAddNote: '',
        }
        this.getsponsorshipList = this.getsponsorshipList.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
        this.updateItem = this.updateItem.bind(this)
    }

    componentDidMount() {
        this.getFillList(sponsorshipTypeActionId, '', '', '', '', '');
        // this.getFillList(adminUserRoleListActionId, '', '', '', '', '');

        this.getsponsorshipList()
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === sponsorshipTypeActionId) {
                        console.log("country data", data.data)
                        // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                        this.setState({
                            sponsorshipList: data.data
                        })
                    }
                    if (actionID === adminUserRoleListActionId) {
                        console.log("country data", data.data)
                        // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                        this.setState({
                            roleList: data.data
                        })
                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    handleSearch() {
        this.getsponsorshipList()
    }

    clearSearch() {
        const { exhibitionID, RoleID, Name } = this.state
        this.setState({
            // ExhCompanyName: '',
            companyName: '',
            sponsorshipTypeId: '',
        })
        setTimeout(() => {
            this.getsponsorshipList()
        }, 100);
    }

    getsponsorshipList() {

        const { ExhCompanyName, VisitorCompanyName, mode, companyName, sponsorshipTypeId } = this.state
        this.setState({ isLoading: true })
        this.props.getSponsershipList_action(mode == 1 ? companyName : null, mode == 2 ? companyName : null, sponsorshipTypeId)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ ExhibitorList: data.data[0], VisitorList: data.data[1] })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Update Current Page
    updateItem(item) {
        const { ExhibitorList, VisitorList, mode } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = mode == 1 ? ExhibitorList.slice(indexOfFirstRecord, indexOfLastRecord) : VisitorList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = mode == 1 ? Math.ceil(ExhibitorList.length / recordsPerPage) : Math.ceil(VisitorList.length / recordsPerPage)
    }

    record(list) {
        return (
            <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0" >
                <thead class="table-light">
                    <tr>
                        {/* <th className="text-center">Role ID</th> */}
                        <th className="text-center">Sr no.</th>
                        <th className="text-center">Sponsorship type</th>
                        <th className="text-center">Registration No</th>
                        <th className="text-center">Person Incharge</th>
                        <th className="text-center">Company Name</th>
                        <th className="text-center">Country</th>
                        <th className="text-center">State</th>
                        <th className="text-center">City</th>
                        <th className="text-center">Mobile</th>
                        <th className="text-center">Email</th>
                        <th className="text-center"
                            style={{
                                // width: '50px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                            }}>Additional Note</th>
                        {/* <th className="text-center">UserName</th>
                        <th className="text-center">Password</th>
                        <th style={{ width: '60px' }} className="text-center">Action</th> */}
                        {/* <th style={{ width: '60px' }} className="text-center"></th> */}

                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    {/* <td className="text-center">{data.RoleID}</td> */}
                                    <td className="text-center">{((this.state.currentPage - 1) * 10) + i + 1}</td>
                                    <td className="text-center">{data.SponsorshipTypeName} </td>
                                    <td className="text-center">{this.state.mode == 1 ? data.ExhRegistrationNo : data.VisitorRegistrationNo}</td>
                                    <td className="text-center">{data[""]}</td>
                                    <td className="text-center">{data.CompanyName}</td>
                                    <td className="text-center">{data.CountryName}</td>
                                    <td className="text-center">{data.State}</td>
                                    <td className="text-center">{data.City}</td>
                                    <td className="text-center">{data.MobileNo}</td>
                                    <td className="text-center">{data.PrimaryEmail}</td>
                                    <td className="" style={{ maxWidth: '200px', width: '200px' }}>
                                        <div onClick={() => this.setState({ selectedAddNote: data.AdditionalNote, isOpen: true })}
                                            style={{
                                                // width: "50px",
                                                cursor: 'pointer',
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis"
                                            }}
                                            title={data.AdditionalNote}

                                        >
                                            {data.AdditionalNote}
                                        </div></td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    render() {
        const { isLoading, selectedAddNote, isOpen, exhibitionList, companyName, currentPage, roleList, Name, mode, ExhibitorList, VisitorList, sponsorshipList, exhibitionID, exhibitionName, roleName, RoleID, sponsorshipTypeId } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = mode == 1 ? ExhibitorList.slice(indexOfFirstRecord, indexOfLastRecord) : VisitorList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = mode == 1 ? Math.ceil(ExhibitorList.length / recordsPerPage) : Math.ceil(VisitorList.length / recordsPerPage)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <div className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"}>
                    <div className="main-container">
                        <AdminDrawer />


                        {/* <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Sponsorship List</h6>
                            </div>
                        </div> */}
                    </div>
                    <div className="navg">
                        <ul className="nav nav-pills with-dr-container tab-scroll-fixed" style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', whiteSpace: 'nowrap' }}>
                            <li className="nav-item ">
                                {" "}
                                <a className={mode == 1 ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"} onClick={() => this.setState({ mode: 1, currentPage: 1, sponsorshipTypeId: '', companyName: '' })}>
                                    Exhibitor{" "}
                                </a>{" "}
                            </li>
                            <li className="nav-item ">
                                {" "}
                                <a className={mode == 2 ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"} onClick={() => this.setState({ mode: 2, currentPage: 1, sponsorshipTypeId: '', companyName: '' })}>
                                    Visitor{" "}
                                </a>{" "}
                            </li>
                        </ul>
                    </div>
                    <div className="p-2 admin-top-space">
                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                            <div className="row m-0 mb-2">
                                {/* <div className="col-xl-3">
                                    <label>Exhibition</label>
                                    <select className="form-control"
                                        value={exhibitionID}
                                        onChange={(e) => this.setState({ exhibitionID: e.target.value })}  >
                                        <option value={''}>Select</option>
                                        {
                                            exhibitionList.length > 0 && exhibitionList.map(data => (
                                                <option value={data.ExhibitionID} key={data.ExhibitionID}>{data.ExhibitionName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-xl-3">
                                    <label>Role</label>
                                    <select className="form-control"
                                        value={RoleID}
                                        onChange={(e) => this.setState({ RoleID: e.target.value })}  >
                                        <option value={''}>Select</option>
                                        {
                                            roleList.length > 0 && roleList.map(data => (
                                                <option value={data.RoleID} key={data.RoleID}>{data.RoleName}</option>
                                            ))
                                        }
                                    </select>
                                </div> */}
                                <div className="col-xl-3">
                                    <label>Company Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        defaultValue=""
                                        required=""
                                        value={companyName}
                                        onChange={(e) => this.setState({ companyName: e.target.value, })}
                                    />
                                </div>
                                <div className="col-xl-3">
                                    <label>Sponsorship type</label>
                                    <select className="form-control"
                                        value={sponsorshipTypeId}
                                        onChange={(e) => this.setState({ sponsorshipTypeId: e.target.value })}  >
                                        <option value={''}>Select</option>
                                        {
                                            sponsorshipList.length > 0 && sponsorshipList.map(data => (
                                                <option value={data.SponsorshipTypeID} key={data.SponsorshipTypeID}>{data.SponsorshipTypeName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                {
                                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                    <div className="col-xl-6 mt-4">
                                        <div
                                            className="mb-1"
                                            aria-label="Basic example"
                                            style={{ float: "right" }}
                                        >
                                            <button type="button" className="btn btn-aqua mt-1 mx-2"
                                                onClick={e => this.handleSearch()}
                                            >
                                                search
                                            </button>
                                            {/* <button type="button" className="btn btn-aqua mx-2 mt-1"
                                                onClick={e => this.handleAdd()}
                                            >
                                                Add
                                            </button> */}
                                            <button type="button" className="btn btn-gray mt-1"
                                                onClick={e => this.clearSearch()}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        < div className="row m-0 mx-2" >

                            <div class="table-responsive px-1 sticky-table-wrapper service-list-grid">
                                {this.record(currentRecords)}
                            </div>
                            <div className="mt-2 float">
                                {mode == 1 ?
                                    ExhibitorList.length > 0 ?
                                        <Pagination
                                            nPages={nPages}
                                            currentPage={currentPage}
                                            setCurrentPage={this.updateItem}
                                        /> : <></> : VisitorList.length > 0 ?
                                        <Pagination
                                            nPages={nPages}
                                            currentPage={currentPage}
                                            setCurrentPage={this.updateItem}
                                        /> : <></>
                                }
                                <div className="tab-rec " style={{ float: "right" }}>
                                    <p>{`${currentPage} of ${nPages} pages`}</p>
                                </div>
                            </div>
                            {/* <div className="mt-2 float-left">
                                    {
                                        exhibitorList.length > 0 ?
                                            <Pagination
                                                nPages={nPages}
                                                currentPage={currentPage}
                                                setCurrentPage={this.updateItem}
                                            /> : <></>
                                    }
                                    <div className="tab-rec " style={{ float: "right" }}>
                                        <p>{`${currentPage} of ${nPages} pages`}</p>
                                    </div>
                                </div> */}
                        </div >
                    </div >
                    <Footer />
                </div >
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Additional Note</h5>

                                {/* <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            <div class="modal-body">
                                <div class="row mx-2">
                                    {selectedAddNote}
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    {/* <button type="button" class="btn btn-aqua"
                                        onClick={(e) => this.deleteUser(this.state.deleteID)}
                                    >Yes</button> */}
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >Ok</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getSponsershipList_action })(SponsorshipList));